import { fetch } from 'utils/redux/action'

// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_CRYPTO_RATES = 'FETCH_CRYPTO_RATES'
export const RECEIVE_CRYPTO_RATES = 'RECEIVE_CRYPTO_RATES'

// ------------------------------------
// Actions
// ------------------------------------
export const actionTypes = {
	fetch: FETCH_CRYPTO_RATES,
	receive: RECEIVE_CRYPTO_RATES
}

// ------------------------------------
// Thunk
// ------------------------------------
export const fetchCryptoRates = () => fetch('cryptoRates', 'cryptorates', actionTypes)
